
/* eslint-disable */
import axios from 'axios';

export default {
    state : {
        executors : [],
    },

    methods : {

    },

    getters : {

        getAllExecutors(state) {

            return state.executors;

        },

        getExecuterById: (state) => (id) => {
            return state.executors.find(item => item.id === id)
        },


    },

    mutations: {
        deleteExecutor(state, id) {
            const index =  state.executors.findIndex(item => item.id === id);
            state.executors.splice(index, 1);
        },

        setExecutors(state, executors) {
            state.executors = executors;
        },

        setExecutor(state, executor) {
            const index =  state.executors.findIndex(item => item.id === executor.id);
            if (index>-1) state.executors.splice(index, 1, executor);
            else state.executors.push(executor);
        }
    
    },

    actions : {



        lockExecutor({ rootState, rootGetters }, id){

            return new Promise((resolve, reject) => {
                axios.post('/executors/lock/' + id, {id:id})
                .then(response => {
                    console.log('lock executors');
                    rootState.ds.event.emit(rootGetters.getPrefix, {'event':'setExecutor', 'content' : response.data});
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
            });

        },
        unlockExecutor({ rootState, rootGetters }, id) {
            return new Promise((resolve, reject) => {
                axios.post('/executors/unlock/' + id, {id:id})
                .then(response => {
                    rootState.ds.event.emit(rootGetters.getPrefix, {'event':'setExecutor', 'content' : response.data});
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
            });
        },

        getAllExecutors({dispatch, commit, rootState }) {

            return new Promise((resolve, reject) => {
                    axios.get('/executors')
                    .then(response => {
                        commit('setExecutors', response.data);
                        resolve(response.data);
                    })
                    .catch(error => {
                        if ((error.response.status == 401)||(error.response.status == 500)) {
                            console.log(error);
                        } else {
                            let t = error.response.status == 429 ? 15000 : 1500;
                            if (error.response.headers["retry-after"] != undefined) t = error.response.headers["retry-after"];
                            setTimeout(()=>{        // повторная загрузка через секунду
                                dispatch('getAllExecutors');
                            }, t);
                            reject(error.response.status)
                        }
                    });
            });
        },

        saveExecuter({dispatch, commit, rootState, rootGetters }, item) {

            return new Promise((resolve, reject) => {
                axios.put('/executors/'+item.id, item)
                .then(response => {
                    rootState.ds.event.emit(rootGetters.getPrefix, {'event':'setExecutor', 'content' : response.data});
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error)
                });
            });

        },

        deleteExecutor({rootState, rootGetters }, item) {

            return new Promise((resolve, reject) => {
                axios.delete('/executors/'+item.id)
                .then(response => {
                    rootState.ds.event.emit(rootGetters.getPrefix, {'event':'deleteExecutor', 'content' : item.id});
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error)
                });
            });

        },


    }

}